import type { SVGComponentProps } from 'BreetHelpers';

export const CloseModal = ({ ...rest }: SVGComponentProps) => (
	<svg
		width='32'
		height='32'
		viewBox='0 0 32 32'
		fill='none'
		xmlns='http://www.w3.org/2000/svg'
		{...rest}
	>
		<rect
			x='0.5'
			y='0.5'
			width='31'
			height='31'
			rx='15.5'
			fill='white'
		/>
		<rect
			x='0.5'
			y='0.5'
			width='31'
			height='31'
			rx='15.5'
			stroke='#ECEEEE'
		/>
		<path
			d='M20.8538 20.1465C20.9002 20.193 20.9371 20.2481 20.9622 20.3088C20.9874 20.3695 21.0003 20.4346 21.0003 20.5003C21.0003 20.566 20.9874 20.631 20.9622 20.6917C20.9371 20.7524 20.9002 20.8076 20.8538 20.854C20.8073 20.9005 20.7522 20.9373 20.6915 20.9625C20.6308 20.9876 20.5657 21.0006 20.5 21.0006C20.4343 21.0006 20.3693 20.9876 20.3086 20.9625C20.2479 20.9373 20.1927 20.9005 20.1463 20.854L16 16.7072L11.8538 20.854C11.76 20.9478 11.6327 21.0006 11.5 21.0006C11.3674 21.0006 11.2401 20.9478 11.1463 20.854C11.0525 20.7602 10.9998 20.633 10.9998 20.5003C10.9998 20.3676 11.0525 20.2403 11.1463 20.1465L15.2932 16.0003L11.1463 11.854C11.0525 11.7602 10.9998 11.633 10.9998 11.5003C10.9998 11.3676 11.0525 11.2403 11.1463 11.1465C11.2401 11.0527 11.3674 11 11.5 11C11.6327 11 11.76 11.0527 11.8538 11.1465L16 15.2934L20.1463 11.1465C20.2401 11.0527 20.3674 11 20.5 11C20.6327 11 20.76 11.0527 20.8538 11.1465C20.9476 11.2403 21.0003 11.3676 21.0003 11.5003C21.0003 11.633 20.9476 11.7602 20.8538 11.854L16.7069 16.0003L20.8538 20.1465Z'
			fill='#748181'
		/>
	</svg>
);
